var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203.41 71.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a8c45125-748c-4ca1-b7ec-b3f1d33ab10e{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f3423a07-e1db-4895-87be-5732fe4d7267",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a8c45125-748c-4ca1-b7ec-b3f1d33ab10e",
    d: "M22.55,39.81,77,7.15a3.63,3.63,0,0,1,3.71,0L180.86,65.3"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.5c70424f.svg";
export { ForwardRef as ReactComponent };